// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"8483f60e","271":"75b1d940","277":"a6a89780","287":"a6a89780","321":"a6a89780","335":"ba816c3a","405":"a6a89780","610":"a6a89780","717":"a6a89780","721":"a6a89780","906":"a6a89780"}[chunkId] + ".chunk.css";
};